import { render, staticRenderFns } from "./StockPosition.vue?vue&type=template&id=5a27fe68&scoped=true&"
import script from "./StockPosition.vue?vue&type=script&lang=js&"
export * from "./StockPosition.vue?vue&type=script&lang=js&"
import style0 from "./StockPosition.vue?vue&type=style&index=0&id=5a27fe68&prod&lang=css&"
import style1 from "./StockPosition.vue?vue&type=style&index=1&id=5a27fe68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27fe68",
  null
  
)

export default component.exports